module.exports = __webpack_public_path__ + "static/media/image 15.b0cde83c.png";